import { render, staticRenderFns } from "./SurveyQuestionnaire.vue?vue&type=template&id=2bcf0e77&scoped=true"
import script from "./SurveyQuestionnaire.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf0e77",
  null
  
)

export default component.exports